import { apiRequest } from './apiClient';

export const fetchMailIds = async () => (await apiRequest('/mail-ids')).data;
export const createMailId = async payload => (await apiRequest('/mail-ids', { method: 'POST', body: JSON.stringify(payload) })).data;
export const updateMailId = async (id, payload) => (await apiRequest(`/mail-ids/${id}`, { method: 'PATCH', body: JSON.stringify(payload) })).data;
export const deleteMailId = async id => apiRequest(`/mail-ids/${id}`, { method: 'DELETE' });
export const resendPendingNotifications = async id =>
  (await apiRequest(`/mail-ids/${id}/resend-pending-notifications`, { method: 'POST' })).data;
